import { styled } from '@material-ui/core/styles';

import Drawer from '@material-ui/core/Drawer';

const DrawerStyled = styled(Drawer)({
	maxWidth: '500',
});

export default DrawerStyled;
